import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _JSON$stringify from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/json/stringify';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';

export default {
  name: 'upload-file-panel',
  data: function data() {
    return {
      dummyFiles: [],
      pdfFile: [],
      fileDirectory: null,
      fileDirectoryOptions: ['External']
    };
  },

  methods: {
    // =============== CLEAR ALL FILES INPUTS ==========
    resetSelectedFiles: function resetSelectedFiles() {
      this.$refs.trainingFileInput.reset();
    },


    // ============ Update the msStatus -> 101 pending approval ==========

    // ============== FILE UPLOAD ACTIONS ==============
    uploadTrainingFiles: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var formData, formDataName, i, name, trainingFileSubmissionInfo, errors, uploadOkay, e, pdfFileList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('\n\n ======= Files Selected [Array]========= \n', this.pdfFile, '\n =================');

                if (this.fileDirectoryOptions.includes(this.fileDirectory)) {
                  _context.next = 5;
                  break;
                }

                alert('Please Select Filed Directory');
                _context.next = 24;
                break;

              case 5:
                if (!(this.pdfFile.length > 7)) {
                  _context.next = 9;
                  break;
                }

                alert('Maximum 7 Files Allowed');
                _context.next = 24;
                break;

              case 9:
                formData = new FormData();
                formDataName = [];

                for (i = 0; i < this.pdfFile.length; i++) {
                  name = 'trainingFile[' + i + ']';

                  console.log('\n\n ------this.pdfFile[' + i + ']------ \n', this.pdfFile[i], name, '\n -----------');
                  formData.append(name, this.pdfFile[i]);
                  formDataName.push(this.pdfFile[i].name);
                }
                console.log('\n\n ======= Files Form [formData]========= \n', formData, '\n =================');

                _context.next = 15;
                return axios.post('/userMsManager/trainingFileUpload/setApplicant', { applicantId: this.$store.state.currentPendingUploadFileUser.id, applicantNricFin: this.$store.state.currentPendingUploadFileUser.nricFin });

              case 15:
                _context.next = 17;
                return axios.post('/userMsManager/trainingFileUpload/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

              case 17:
                trainingFileSubmissionInfo = _context.sent.data;


                console.log('\n\n=======trainingFileSubmissionInfo========\n', trainingFileSubmissionInfo.errors, '\n ===========');
                // Object.keys(trainingFileSubmissionInfo.errors).length?
                //   alert(JSON.stringify(trainingFileSubmissionInfo.errors)):
                //   alert('File Successfully Updated');

                // JSON.stringify(trainingFileSubmissionInfo.errors) !="{}"?
                //         alert(JSON.stringify(trainingFileSubmissionInfo.errors)):
                //         alert('File Successfully Updated');

                errors = JSON.parse(_JSON$stringify(trainingFileSubmissionInfo.errors));
                uploadOkay = true;


                if (_JSON$stringify(errors) == '{}') {
                  uploadOkay = true;
                } else {
                  // errors.forEach(e =>{
                  for (e in errors) {
                    uploadOkay = !errors[e].hasOwnProperty('dupFileUpload') && uploadOkay;
                  }
                }

                if (uploadOkay) {
                  alert('File Successfully Updated');
                } else {
                  alert(_JSON$stringify(trainingFileSubmissionInfo.errors));
                }

                this.resetSelectedFiles();

              case 24:
                pdfFileList = [];

                this.pdfFile.forEach(function (pdf) {
                  pdfFileList.push(pdf.name);
                });
                this.$emit('uploadTrainingFiles', [].concat(pdfFileList));

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadTrainingFiles() {
        return _ref.apply(this, arguments);
      }

      return uploadTrainingFiles;
    }(),


    // ============= CHANGE FILE DIR ==============
    changeFileDirectory: function changeFileDirectory(item, inputForm) {
      this.fileDirectory = item;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/bookModuleSession/UploadFilePanel.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/bookModuleSession/UploadFilePanel.vue
// module chunks = 0 5 8 12